import React, { Suspense } from 'react'
import { ApolloProvider } from '@apollo/client'
import styled from 'styled-components'
import { client } from '../../apollo/client'
import '../../i18n'
import CentredLoader from '../CentredLoader'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

interface Props {
  children: React.ReactNode
}

const Template = (props: Props): JSX.Element => (
  <ApolloProvider client={client}>
    <Suspense fallback={<CentredLoader tip="Loading..." size="large" />}>
      <Wrapper>{props.children}</Wrapper>
    </Suspense>
  </ApolloProvider>
)

const Wrapper = styled.div`
  .custom-editor {
    border-radius: 2px;
    border: 1px solid #f1f1f1;
  }
`

export default Template
